import { fetchChallengeLead } from '@actions/challenges';
import {
    getChallengeLeads,
    getChallengesFetchError,
    getChallengesIsFetching,
} from '@selectors/challenges';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallengeLeads = (challengeID: number) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchChallengeLead(challengeID));
    }, [dispatch, challengeID]);

    const leads = useSelector(getChallengeLeads);
    const isFetching = useSelector(getChallengesIsFetching);
    const fetchError = useSelector(getChallengesFetchError);

    return { leads, isFetching, fetchError };
};

export default useFetchChallengeLeads;
